export default {"src":"/_next/static/media/dots.25ddac30.svg","height":429,"width":419,"blurWidth":0,"blurHeight":0};